import  React  from 'react';
import { Icon } from 'antd';
class ConflictDisplayPanel extends React.Component {


  onOk = () => {
    const { onOk } = this.props;
    if(typeof onOk == 'function') onOk();
    this.closePanel();
  }

  onCancel = () => {
    const { onCancel } = this.props;
    if(typeof onCancel == 'function') onCancel();
    this.closePanel();
  }

  closePanel = () => {
    $('#conflict-panel-box').css({visibility: 'hidden'});
  };
  
  componentDidMount() {
    this.setPanelPosition();
   }
   componentDidUpdate() {
     this.setPanelPosition();
   }
  
  //设置操作者信息面板的相对位置
  setPanelPosition() {
    const { clickPos:{ posX, posY },content } = this.props;
    let panel = document.getElementById('conflict-panel-box');
    if(!panel) return
    let container = document.getElementsByClassName('wea-new-top-req-content')[0];
    let panelWd  = panel.offsetWidth;
    let panelHg = panel.offsetHeight;
    let maxWd = document.documentElement.clientWidth;
    let maxHg = document.documentElement.clientHeight;
    //处理边缘防撞
    if(posX + panelWd  >= maxWd) {
      panel.style.left = maxWd - panelWd - 10+ 'px';
    } else {
      panel.style.left = posX + 10 + 'px';
    }
    if(posY + panelHg  >= maxHg) {
      panel.style.top =  maxHg - panelHg - 10 + 'px';
    } else {
      panel.style.top = posY + 10 + 'px';
     }
  }

  render() {
    const { clickPos:{ posX, posY },content } = this.props;
    return(
      <React.Fragment ecId={`${this && this.props && this.props.ecId || ''}_undefined@qt1byo`}>
        {
          <div className='conflict-panel-container'>
            <div className='panel-header'>
              <p>您此次的修改</p>
              <div className='close-btn' onClick={this.closePanel}>
                <Icon ecId={`${this && this.props && this.props.ecId || ''}_Icon@rgipux`} type="cross" />
              </div>
            </div>
            <div className='panel-body'>{content}</div>
            <div className='panel-footer'>
              <div className='btn active' onClick={this.onOk}>确认修改</div>
              <div className='btn' onClick={this.onCancel}>忽略</div>
            </div>
          </div>
        }
      </React.Fragment>
    )
  }
}

export default ConflictDisplayPanel


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/layout/ConflictDisplayPanel.js